export const metricTypeNPS = [0, 1, 2]
export const metricTypeCSAT = [7, 8, 9]
